import { enGB } from "date-fns/locale";

/** Matches en-GB display used in event previews (dd/MM/yyyy). */
export const EVENT_DATE_PICKER_FORMAT = "dd/MM/yyyy";

/** Locale for all dashboard date pickers (event details, scheduling, recurrence). */
export const EVENT_DATE_PICKER_LOCALE = enGB;

export function formatEventDisplayDate(
  value: Date | string | null | undefined,
): string {
  if (!value) return "";

  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
